import React, { useState } from 'react';
import  {Dialog, Classes}  from "@blueprintjs/core";
import Endpoints from "../../../endpoints.js";

/**
 *
 * @param {Object} props
 * @param {Agente} props.currentAgent
 * @returns {JSX.Element}
 * @constructor
 */
export default function SearchContactDialog(props) {
  const [query, setQuery] = useState('');
  const [contacts, setContacts] = useState([]);

  //const [contacts, setContacts] = useState([{"numeroClienteIde":"001234","numeroCliente":"004321","nombreCompleto":"FULANITO PEREZ JUAREZ","nombres":"FULANITO","apellidoPaterno":"PEREZ","apellidoMaterno":"JUAREZ","tipoPersona":"Persona Fisica Sin Actividad Empresarial","numeroPersona":"00012354","idPromotorOrigen":"999999","idPromotorAtiende":"000243","estatusCliente":"Activo","telefonoCasa":"81-12-34-56","telefonoCelular":"81 14134670","email":"correo@correo.com"},{"numeroClienteIde":"001235","numeroCliente":"004321","nombreCompleto":"FULANITO PEREZ JUAREZ","nombres":"FULANITO","apellidoPaterno":"PEREZ","apellidoMaterno":"JUAREZ","tipoPersona":"Persona Fisica Sin Actividad Empresarial","numeroPersona":"00012354","idPromotorOrigen":"999999","idPromotorAtiende":"000243","estatusCliente":"Activo","telefonoCasa":"81-12-34-56","telefonoCelular":"81 14134670","email":"correo@correo.com"}]);
  const [loading, setLoading] = useState(false);

  const tipo = "busca-clientes";

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);
    console.log(props.currentAgent.usuario);
    // fetch(`http://brmdapienterprise:8075/api/clientes?filtro=${encodeURIComponent(query)}&limit=5`)
    //fetch(`http://localhost:81/api/clientes?filtro=${encodeURIComponent(query)}&limit=3`)

    fetch(Endpoints().CLIENTS_URL(tipo,props.currentAgent.usuario.idPromotor, encodeURIComponent(query), 5), {
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer "+ props.currentAgent.stsTokenManager.accessToken
      },
      method: "GET"
      })
    //fetch(`https://anypoint.mulesoft.com/mocking/api/v1/sources/exchange/assets/af38bb5b-75d7-4f4d-bb0d-a3b795130617/datos-cliente-sys/1.0.8/m/clientes?filtro=${encodeURIComponent(query)}&limit=3`)
      .then(response => response.json())
      .then(contactsData => {
        if (contactsData !== null && Array.isArray(contactsData)
        ) {
            setContacts(contactsData.slice(0,3))
        } else {
            console.log('Falla al consultar la cartera, el directorio esta vacio');
        }
    })
        
      .finally(() => setLoading(false))
  }

  const handleSearch = e => {
    setQuery(e.target.value.trim().toUpperCase());
  }

  const chooseContact = contact => {
    if(window.confirm(`¿Estás seguro de contactar a ${contact.nombreCompleto}?`)) {
      setContacts([])
      props.setContact(contact);
    }
  }

  const renderContact = c => {
    return (
      <div key={c.numeroClienteIde} className="list-group-item list-group-item-action" onClick={chooseContact.bind(this, c)} style={{cursor: "pointer"}}>
        <div className="d-flex w-100 justify-content-between">
          <h5 className="mb-1">{c.nombreCompleto}</h5>
          <small></small>
        </div>
        <p className="mb-1">No. Cliente: {c.numeroClienteIde}</p>
        <p className="mb-1"></p>
        <small>Cel: {c.telefonoCelular} &mdash; Email: {c.email}</small>
      </div>
    )
  }

  const handleClose = () => {
    setContacts([]);
    props.close();
  }

  return (
      <Dialog
          icon="new-person"
          onClose={handleClose}
          title='Nuevo mensaje'
          isOpen= {props.isOpen}>
            <div className={Classes.DIALOG_BODY}>
              <form onSubmit={handleSubmit}>
                <div className="row align-items-center">
                  <div className="col">
                    <div className="input-group mb-3 input-group-lg">
                      <input
                        onChange={handleSearch}
                        autoFocus={true}
                        title="Al menos 5 caracteres"
                        required
                        pattern=".{5,}"
                        type="text"
                        className="form-control"
                        placeholder="Buscar contacto..." />
                    </div>
                  </div>
                </div>
                <div className="row align-items-center">
                  <div className="col">
                    {loading ? (
                      <div className="bp3-progress-bar">
                        <div className="bp3-progress-meter" style={{width: "100%"}}></div>
                      </div>
                      ): ""}
                    <div className="list-group">
                      {contacts.map(x => renderContact(x))}
                    </div>
                  </div>
                </div>
              </form>
            </div>
      </Dialog>
  )
}
